import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const ToastContext = createContext({
  showSuccess: () => {},
  showError: () => {},
  showInfo: () => {}
});

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  const show = useCallback((message, severity = 'info') => {
    setToast({ open: true, message, severity });
  }, []);

  const showSuccess = useCallback((message) => show(message, 'success'), [show]);
  const showError = useCallback((message) => show(message, 'error'), [show]);
  const showInfo = useCallback((message) => show(message, 'info'), [show]);

  const handleClose = useCallback(() => {
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  const contextValue = useMemo(() => ({ showSuccess, showError, showInfo }), [showSuccess, showError, showInfo]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <Snackbar
        open={toast.open}
        autoHideDuration={3500}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleClose} severity={toast.severity} variant="filled" sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
